<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>热门搜索标签设置</h3>
                </el-col>
            </el-row>
            <el-form :model="hotForm" ref="hotForm">
                <el-form-item label="热门关键词设置" label-width="150px">
                    <el-input v-model="hot" style="width: 200px;"></el-input>
                    <el-button type="success" @click="handleAdd">添加</el-button>
                </el-form-item>
                <el-form-item label="描述" label-width="150px">
                    <div>
                        <el-tag type="warning" v-for="item in row" :key="item" :closable="true" :close-transition="false" @close="handleClose(item)" style="margin-right: 10px;">{{ item }}</el-tag>
                    </div>

                </el-form-item>

                <el-form-item label-width="150px">
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>

<script>
import {
    getHot,
    patchHot
} from '../../api/version'

export default {
    data() {
        return {
            hotForm: {},
            hot: '',
            row: ''
        }
    },
    created() {
        getHot(sessionStorage.userId).then(res => {
            let data = res.data
            this.row = data.SettingValue.split(',')
            console.log(this.row)
        })
    },
    methods: {

        onSubmit() {
            patchHot(sessionStorage.userId, { 'SettingValue': this.row.join(',') }).then(res => {
                console.log(res)
                if (res.data) {
                    this.$message({
                        message: '成功更新热门搜索标签',
                        type: 'success'
                    });
                }else{
                    this.$message.error('更新标签失败')
                }
            }, err => {
                this.$message.error('更新标签失败')
            })
        },
        handleAdd() {
            if (this.hot) {
                this.row.push(this.hot)
                this.hot = ''
            }
        },
        handleClose(tag) {
            this.row.splice(this.row.indexOf(tag), 1);
        }



    }
}
</script>

<style>
.user-pic {
    width: 50px;
    height: 50px;
    margin-top: 10px;
}

.avatar-uploader .el-upload {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.page-footer {
    margin-top: 60px;
    text-align: center;
}
</style>




// WEBPACK FOOTER //
// HotSearch.vue?6f57a9bf